

// To make the canvas inner element accessible while taking screenshot
// Used to convert mapMyIndia map to image
HTMLCanvasElement.prototype.getContext = function(origFn) {
    return function(type, attribs) {
        attribs = attribs || {};
        attribs.preserveDrawingBuffer = true;
        return origFn.call(this, type, attribs);
    };
}(HTMLCanvasElement.prototype.getContext);


import React from "react";
import ReactDOM from "react-dom/client";
import "@techsoftware/happay-widgets/ProductStyles/index.scss";

import { I18nextProvider } from "react-i18next";
import i18next from "./i18nNext";

import Routes from "./routes";

const container = document.getElementById("app");
const root = ReactDOM.createRoot(container);

root.render(
    <I18nextProvider i18n={i18next}>
        <Routes />
    </I18nextProvider>
);
